module.exports = __webpack_public_path__ + "components/flag/static/square/cc-5dfa63e713e7e6273795b2d9ab97d970.svg";